import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import './DataTable.css';

export default function DataTable({ columns, data, loading, emptyMsg, rowClass, hideSearch }) {
  const { t } = useLanguage();
  const [search, setSearch] = useState('');

  const filtered = search
    ? data.filter(row =>
        columns.some(col => {
          const val = col.accessor ? row[col.accessor] : '';
          return String(val || '').toLowerCase().includes(search.toLowerCase());
        })
      )
    : data;

  if (loading) return (
    <div className="table-loading">
      <div className="spinner"></div>
      <span>{t('common.loading')}</span>
    </div>
  );

  return (
    <div className="data-table-wrap">
      <div className="table-toolbar">
        {!hideSearch && (
        <input
          className="table-search"
          placeholder={t('common.searchPlaceholder')}
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        )}
        <span className="table-count">{filtered.length} {t('common.result')}</span>
      </div>
      <div className="table-scroll">
        <table className="data-table">
          <thead>
            <tr>
              {columns.map((col, i) => (
                <th key={i} style={{ width: col.width }}>{col.header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr><td colSpan={columns.length} className="empty-row">{emptyMsg || t('common.noData')}</td></tr>
            ) : (
              filtered.map((row, i) => (
                <tr key={i} className={rowClass ? rowClass(row) : undefined}>
                  {columns.map((col, j) => (
                    <td key={j}>{col.render ? col.render(row, i) : row[col.accessor]}</td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
